export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-960-280ebeddc0056b3ea58d728b057a7c09.png";